var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5171_36)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.91661 6.74998L6.7501 7.91649L16.0836 17.25L17.2501 16.0835L7.91661 6.74998Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 1.49996C10.6187 1.49137 9.24949 1.7571 7.97169 2.28174C6.6939 2.80637 5.53297 3.57947 4.55625 4.5562C3.57952 5.53293 2.80642 6.69385 2.28178 7.97165C1.75715 9.24944 1.49142 10.6187 1.5 12C1.49142 13.3812 1.75715 14.7505 2.28178 16.0283C2.80642 17.3061 3.57952 18.467 4.55625 19.4437C5.53297 20.4204 6.6939 21.1935 7.97169 21.7182C9.24949 22.2428 10.6187 22.5085 12 22.5C13.3813 22.5085 14.7505 22.2428 16.0283 21.7182C17.3061 21.1935 18.467 20.4204 19.4438 19.4437C20.4205 18.467 21.1936 17.3061 21.7182 16.0283C22.2429 14.7505 22.5086 13.3812 22.5 12C22.5086 10.6187 22.2429 9.24944 21.7182 7.97165C21.1936 6.69385 20.4205 5.53293 19.4438 4.5562C18.467 3.57947 17.3061 2.80637 16.0283 2.28174C14.7505 1.7571 13.3813 1.49137 12 1.49996ZM12 21C10.22 21 8.47991 20.4721 6.99987 19.4832C5.51983 18.4943 4.36628 17.0886 3.68509 15.4441C3.0039 13.7996 2.82567 11.99 3.17294 10.2441C3.5202 8.49832 4.37737 6.89467 5.63604 5.636C6.89472 4.37732 8.49836 3.52016 10.2442 3.17289C11.99 2.82562 13.7996 3.00385 15.4442 3.68504C17.0887 4.36623 18.4943 5.51978 19.4832 6.99983C20.4722 8.47987 21 10.2199 21 12C20.993 14.3848 20.0426 16.6699 18.3563 18.3562C16.6699 20.0425 14.3848 20.993 12 21Z",
  fill: "currentColor"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5171_36"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgPlaceholderIcon = function SvgPlaceholderIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlaceholderIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PlaceholderIcon.66535b2d.svg";
export { ForwardRef as ReactComponent };